/**
 * Hvem flyttet kartet — brukeren eller appen?
 *
 * Markørhentingen må vite dette: flyttet APPEN kartet (søketreff, «vis i kart»,
 * valgt plass), har brukeren alt uttrykt hvor hen vil se, og vi henter med én
 * gang. Flyttet BRUKEREN det selv, tilbyr vi «Søk i dette området» i stedet for
 * å bruke en henting hen ikke ba om.
 *
 * FØR ble dette gjettet: «userDragged» ble satt på Leaflets `dragend`, og alt
 * annet ble regnet som programmatisk. Da ble hver eneste ZOOM med hjulet, +/−
 * knappene, dobbeltklikk eller knip regnet som appens eget flytt — og
 * søkesirkelen dukket opp av seg selv uten at brukeren hadde trykket på noe.
 *
 * Nå snus det: appen SIER FRA når den flytter kartet selv. Alt annet er
 * brukeren. Det er ett sted å vedlikeholde, og det gjetter ikke.
 *
 * Tidsvinduet finnes fordi flyttet er animert (`flyTo` bruker 2 s) og `moveend`
 * kommer først når animasjonen er ferdig.
 */

let programmatiskTil = 0;

/** Appen flytter kartet nå. Kall FØR flyTo/setView/fitBounds. */
export const markProgrammaticMove = (varighetMs = 2600): void => {
  programmatiskTil = Date.now() + varighetMs;
};

/** Er flyttet som akkurat skjedde appens eget? */
export const isProgrammaticMove = (): boolean => Date.now() < programmatiskTil;

/** Nullstill — brukes av tester. */
export const resetProgrammaticMove = (): void => {
  programmatiskTil = 0;
};
